module.exports = __webpack_public_path__ + "img/hong_kong_2015_3.7fa91885.png";